var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// lib/configuration/NotifiFrontendConfiguration.ts
var checkIsConfigWithPublicKeyAndAddress = (config) => {
  return "accountAddress" in config;
};
var checkIsConfigWithDelegate = (config) => {
  return "delegatedAddress" in config;
};
var checkIsConfigWithOidc = (config) => {
  return config.walletBlockchain === "OFF_CHAIN";
};
var evmChains = [
  "ETHEREUM",
  "POLYGON",
  "ARBITRUM",
  "AVALANCHE",
  "BINANCE",
  "OPTIMISM",
  "THE_ROOT_NETWORK",
  "BASE",
  "BLAST",
  "CELO",
  "MANTLE",
  "LINEA",
  "SCROLL",
  "MANTA",
  "MONAD",
  "ZKSYNC",
  "BERACHAIN"
];
var isEvmChain = (chain) => {
  return !!evmChains.find((c) => c === chain);
};
var configFactoryPublicKey = (args) => {
  let walletPublicKey = args.account.publicKey;
  if (isEvmChain(args.walletBlockchain)) {
    walletPublicKey = walletPublicKey.toLowerCase();
  }
  return {
    tenantId: args.tenantId,
    env: args.env,
    walletBlockchain: args.walletBlockchain,
    walletPublicKey,
    storageOption: args.storageOption
  };
};
var configFactoryPublicKeyAndAddress = (args) => {
  return {
    tenantId: args.tenantId,
    env: args.env,
    walletBlockchain: args.walletBlockchain,
    authenticationKey: args.account.publicKey,
    accountAddress: args.account.address,
    storageOption: args.storageOption
  };
};
var configFactoryDelegated = (args) => {
  return {
    tenantId: args.tenantId,
    env: args.env,
    walletBlockchain: args.walletBlockchain,
    delegatedAddress: args.account.address,
    delegatedPublicKey: args.account.publicKey,
    delegatorAddress: args.account.delegatorAddress,
    storageOption: args.storageOption
  };
};
var configFactoryOidc = (args) => {
  return {
    tenantId: args.tenantId,
    env: args.env,
    userAccount: args.account.userAccount,
    storageOption: args.storageOption,
    walletBlockchain: args.walletBlockchain
  };
};
var isWithPubkeyAndAddress = (config) => {
  return "address" in config.account && !isWithDelegate(config);
};
var isWithDelegate = (config) => {
  return "delegatorAddress" in config.account;
};
var isWithOidc = (config) => {
  return "userAccount" in config.account && config.walletBlockchain === "OFF_CHAIN";
};
var newFrontendConfig = (config) => {
  if (isWithOidc(config)) {
    return configFactoryOidc(config);
  } else if (isWithDelegate(config)) {
    return configFactoryDelegated(config);
  } else if (isWithPubkeyAndAddress(config)) {
    return configFactoryPublicKeyAndAddress(config);
  } else {
    return configFactoryPublicKey(config);
  }
};
var envUrl = (env, endpointType) => {
  if (!env) env = "Production";
  let url = "";
  switch (env) {
    case "Development":
      url = "://api.dev.notifi.network/gql";
      break;
    case "Local":
      url = "://localhost:5001/gql";
      break;
    case "Production":
      url = "://api.notifi.network/gql";
      break;
    case "Staging":
      url = "://api.stg.notifi.network/gql";
  }
  return `${endpointType === "websocket" ? "wss" : env === "Local" ? "http" : "https"}${url}`;
};

// lib/utils/notNullOrEmpty.ts
var notNullOrEmpty = (item) => {
  return item !== void 0 && item !== null;
};

// lib/utils/packFilterOptions.ts
var packFilterOptions = (clientOptions) => {
  if (clientOptions === null) {
    return "{}";
  }
  return JSON.stringify(clientOptions);
};

// lib/utils/resolveRef.ts
var createRefResolver = (validator) => {
  return (name, valueOrRef, inputs) => {
    if (valueOrRef.type === "value") {
      return valueOrRef.value;
    } else {
      if (valueOrRef.ref === null) {
        throw new Error(`Invalid configuration: Ref ${name} is null`);
      }
      const runtimeInput = inputs[valueOrRef.ref];
      if (validator(runtimeInput)) {
        return runtimeInput;
      } else {
        throw new Error(`Invalid value provided for ${name}: ${runtimeInput}`);
      }
    }
  };
};
var resolveStringRef = createRefResolver(
  (item) => {
    return typeof item === "string";
  }
);
var resolveNumberRef = createRefResolver(
  (item) => {
    return typeof item === "number" && !Number.isNaN(item);
  }
);
var resolveStringArrayRef = createRefResolver(
  (item) => {
    return Array.isArray(item) && item.every((element) => typeof element === "string");
  }
);
var resolveCheckRatioArrayRef = createRefResolver(
  (item) => {
    return Array.isArray(item) && item.every(
      (element) => typeof element === "object" && typeof element.type === "string" && typeof element.ratio === "number" && !Number.isNaN(element.ratio)
    );
  }
);
var resolveObjectArrayRef = createRefResolver(
  (item) => {
    return Array.isArray(item) && item.every((element) => typeof element === "object") && item.every((element) => {
      return "label" in element && typeof element.label === "string" && "value" in element && typeof element.value === "string";
    });
  }
);

// lib/utils/typeUtils.ts
var objectKeys = (object) => {
  return Object == null ? void 0 : Object.keys(object);
};

// lib/utils/areIdsEqual.ts
var areIdsEqual = (ids, items) => {
  const idSet = new Set(ids);
  return items.length === idSet.size && items.every(
    (it) => it !== void 0 && it.id !== void 0 && idSet.has(it.id)
  );
};

// lib/client/ensureSource.ts
var ensureDirectPushSource = async (service, _eventType, _inputs) => {
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  const source = sources == null ? void 0 : sources.find(
    (it) => it !== void 0 && it.type === "DIRECT_PUSH"
  );
  if (source === void 0) {
    throw new Error("Failed to identify direct push source");
  }
  return source;
};
var ensureFusionSource = async (service, eventType, inputs) => {
  const address = resolveStringRef(
    eventType.name,
    eventType.sourceAddress,
    inputs
  );
  const eventTypeId = resolveStringRef(
    eventType.name,
    eventType.fusionEventId,
    inputs
  );
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  const existing = sources == null ? void 0 : sources.find(
    (it) => it !== void 0 && it.type === "FUSION_SOURCE" && it.blockchainAddress === address && it.fusionEventTypeId === eventTypeId
  );
  if (existing !== void 0) {
    return existing;
  }
  const createMutation = await service.createSource({
    type: "FUSION_SOURCE",
    blockchainAddress: address,
    fusionEventTypeId: eventTypeId
  });
  const source = createMutation.createSource;
  if (source === void 0) {
    throw new Error("Failed to create source");
  }
  return source;
};
var ensureBroadcastSource = async (service, eventType, inputs) => {
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  if (sources === void 0) {
    throw new Error("Failed to fetch sources");
  }
  const address = resolveStringRef(
    eventType.name,
    eventType.broadcastId,
    inputs
  );
  const existing = sources.find(
    (it) => (it == null ? void 0 : it.type) === "BROADCAST" && it.blockchainAddress === address
  );
  if (existing !== void 0) {
    return existing;
  }
  const createMutation = await service.createSource({
    type: "BROADCAST",
    blockchainAddress: address
  });
  const result = createMutation.createSource;
  if (result === void 0) {
    throw new Error("Failed to create source");
  }
  return result;
};
var ensureTradingPairSource = async (service, _eventType, _inputs) => {
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  const source = sources == null ? void 0 : sources.find((it) => (it == null ? void 0 : it.type) === "DIRECT_PUSH");
  if (source === void 0) {
    throw new Error("Failed to identify trading pair source (=directPush)");
  }
  return source;
};
var ensurePriceChangeSources = async (service, eventType, _inputs) => {
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  if (sources === void 0) {
    throw new Error("Failed to fetch sources");
  }
  const results = [];
  const sourcesToCreate = new Set(eventType.tokenIds);
  sources.forEach((existing) => {
    if ((existing == null ? void 0 : existing.type) === "COIN_PRICE_CHANGES") {
      sourcesToCreate.delete(existing.blockchainAddress);
      results.push(existing);
    }
  });
  if (sourcesToCreate.size > 0) {
    let createSourcePromise = Promise.resolve();
    sourcesToCreate.forEach((tokenId) => {
      createSourcePromise = createSourcePromise.then(async () => {
        const result = await service.createSource({
          type: "COIN_PRICE_CHANGES",
          blockchainAddress: tokenId
        });
        const source = result.createSource;
        if (source !== void 0) {
          results.push(source);
        }
      });
    });
    await createSourcePromise;
  }
  return results;
};
var ensureWalletBalanceSources = async (service, _eventType, _inputs) => {
  const connectedWalletsQuery = await service.getConnectedWallets({});
  const connectedWallets = connectedWalletsQuery.connectedWallet;
  if (!connectedWallets) {
    throw new Error("Failed to fetch connected wallets");
  }
  const connectedWalletSources = connectedWallets.map((it) => {
    var _a;
    const sourceType = ((wallet) => {
      switch (wallet) {
        case "ACALA":
          return "ACALA_WALLET";
        case "APTOS":
          return "APTOS_WALLET";
        case "MOVEMENT":
          return "MOVEMENT_WALLET";
        case "ARBITRUM":
          return "ARBITRUM_WALLET";
        case "AVALANCHE":
          return "AVALANCHE_WALLET";
        case "BINANCE":
          return "BINANCE_WALLET";
        case "ETHEREUM":
          return "ETHEREUM_WALLET";
        case "THE_ROOT_NETWORK":
          return "THE_ROOT_NETWORK";
        case "BASE":
          return "ETHEREUM_WALLET";
        case "BLAST":
          return "BLAST_WALLET";
        case "CELO":
          return "CELO_WALLET";
        case "MANTLE":
          return "MANTLE_WALLET";
        case "LINEA":
          return "LINEA_WALLET";
        case "MONAD":
          return "MONAD_WALLET";
        case "MANTA":
          return "MANTA_WALLET";
        case "SCROLL":
          return "SCROLL_WALLET";
        case "POLYGON":
          return "POLYGON_WALLET";
        case "SOLANA":
          return "SOLANA_WALLET";
        case "OPTIMISM":
          return "OPTIMISM_WALLET";
        case "SUI":
          return "SUI_WALLET";
        case "ZKSYNC":
          return "ZKSYNC_WALLET";
        case "ARCHWAY":
          return "ARCHWAY_WALLET";
        case "ELYS":
          return "ELYS_WALLET";
        case "AXELAR":
          return "AXELAR_WALLET";
        case "NEUTRON":
          return "NEUTRON_WALLET";
        case "BERACHAIN":
          return "BERACHAIN_WALLET";
        case "XION":
          return "XION_WALLET";
        case "AGORIC":
          return "AGORIC_WALLET";
        case "ORAI":
          return "ORAI_WALLET";
        case "KAVA":
          return "KAVA_WALLET";
        case "CELESTIA":
          return "CELESTIA_WALLET";
        case "COSMOS":
          return "COSMOS_WALLET";
        case "DYMENSION":
          return "DYMENSION_WALLET";
        case "PERSISTENCE":
          return "PERSISTENCE_WALLET";
        case "DYDX":
          return "DYDX_WALLET";
        default:
          throw new Error("Unsupported walletType");
      }
    })(it == null ? void 0 : it.walletBlockchain);
    const sourceAddress = (_a = it == null ? void 0 : it.address) != null ? _a : "";
    return {
      name: `${sourceType} ${sourceAddress}`,
      blockchainAddress: sourceAddress,
      type: sourceType
    };
  });
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  if (sources === void 0) {
    throw new Error("Failed to fetch sources");
  }
  const promises = connectedWalletSources.map(async (connectedWalletSource) => {
    const found = sources.find(
      (source) => (source == null ? void 0 : source.name) === connectedWalletSource.name
    );
    if (found) {
      return found;
    }
    const { createSource: newSource } = await service.createSource(
      connectedWalletSource
    );
    if (!newSource) {
      throw new Error(`Failed to create ${connectedWalletSource.type} source`);
    }
    return newSource;
  });
  const ensuredSources = await Promise.all(promises);
  return ensuredSources;
};
var normalizeSourceAddress = (sourceType, blockchainAddress) => {
  switch (sourceType) {
    case "ETHEREUM_WALLET":
    case "POLYGON_WALLET":
    case "ARBITRUM_WALLET":
    case "BINANCE_WALLET":
    case "OPTIMISM_WALLET":
    case "AVALANCHE_WALLET":
    case "ZKSYNC_WALLET":
    case "BENQI":
    case "DELTA_PRIME":
    case "DELTA_PRIME_LENDING_RATES":
    case "MOVEMENT_WALLET":
    case "APTOS_WALLET":
      return normalizeHexString(blockchainAddress);
    default:
      return blockchainAddress;
  }
};
var normalizeHexString = (input) => {
  let result = input;
  if (input !== "") {
    result = input.toLowerCase();
    if (!result.startsWith("0x")) {
      result = "0x" + result;
    }
  }
  return result;
};
var ensureCustomSources = async (service, eventType, inputs) => {
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  if (sources === void 0) {
    throw new Error("Failed to fetch sources");
  }
  const address = resolveStringRef(
    eventType.name,
    eventType.sourceAddress,
    inputs
  );
  const sourceAddress = normalizeSourceAddress(eventType.sourceType, address);
  const existing = sources.find(
    (it) => (it == null ? void 0 : it.type) === eventType.sourceType && it.blockchainAddress === sourceAddress
  );
  if (existing !== void 0) {
    return existing;
  }
  const createMutation = await service.createSource({
    type: eventType.sourceType,
    blockchainAddress: sourceAddress
  });
  const result = createMutation.createSource;
  if (result === void 0) {
    throw new Error("Failed to create source");
  }
  return result;
};
var ensureXMTPSources = async (service, eventType, inputs) => {
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  if (sources === void 0) {
    throw new Error("Failed to fetch sources");
  }
  const XMTPTopics = resolveStringArrayRef(
    eventType.name,
    eventType.XMTPTopics,
    inputs
  );
  const XMTPTopicSources = XMTPTopics.map((topic) => ({
    name: topic,
    blockchainAddress: topic,
    type: "XMTP"
  }));
  const promises = XMTPTopicSources.map(async (source) => {
    const found = sources.find(
      (it) => (it == null ? void 0 : it.type) === "XMTP" && it.name === source.name
    );
    if (found) {
      return found;
    }
    const { createSource: newSource } = await service.createSource(source);
    if (!newSource) {
      throw new Error("Failed to create XMTP source");
    }
    return newSource;
  });
  const ensuredSources = await Promise.all(promises);
  return ensuredSources;
};
var ensureHealthCheckSources = async (service, _eventType, _inputs) => {
  const sourcesQuery = await service.getSources({});
  const sources = sourcesQuery.source;
  const source = sources == null ? void 0 : sources.find((it) => (it == null ? void 0 : it.type) === "DIRECT_PUSH");
  if (source === void 0) {
    throw new Error("Failed to identify Health Check source (=directPush)");
  }
  return source;
};
var ensureSources = async (service, eventType, inputs) => {
  switch (eventType.type) {
    case "directPush": {
      const source = await ensureDirectPushSource(service, eventType, inputs);
      return [source];
    }
    case "broadcast": {
      const source = await ensureBroadcastSource(service, eventType, inputs);
      return [source];
    }
    case "tradingPair": {
      const source = await ensureTradingPairSource(service, eventType, inputs);
      return [source];
    }
    case "priceChange": {
      const sources = await ensurePriceChangeSources(
        service,
        eventType,
        inputs
      );
      return sources;
    }
    case "walletBalance": {
      const sources = await ensureWalletBalanceSources(
        service,
        eventType,
        inputs
      );
      return sources;
    }
    case "custom": {
      const source = await ensureCustomSources(service, eventType, inputs);
      return [source];
    }
    case "XMTP": {
      const sources = await ensureXMTPSources(service, eventType, inputs);
      return sources;
    }
    case "healthCheck": {
      const source = await ensureHealthCheckSources(service, eventType, inputs);
      return [source];
    }
    case "fusionToggle":
    case "fusion": {
      const source = await ensureFusionSource(service, eventType, inputs);
      return [source];
    }
    case "label": {
      throw new Error("Unsupported event type");
    }
    default:
      throw new Error("Unsupported event type");
  }
};
var ensureSourceGroup = async (service, name, sourceIds) => {
  var _a, _b;
  const sourceGroupsQuery = await service.getSourceGroups({});
  const existing = (_a = sourceGroupsQuery.sourceGroup) == null ? void 0 : _a.find(
    (it) => it !== void 0 && it.name === name
  );
  if (existing === void 0) {
    const createMutation = await service.createSourceGroup({
      name,
      sourceIds
    });
    const createResult = createMutation.createSourceGroup;
    if (createResult === void 0) {
      throw new Error("Failed to create source group");
    }
    return createResult;
  }
  if (areIdsEqual(sourceIds, (_b = existing.sources) != null ? _b : [])) {
    return existing;
  }
  const updateMutation = await service.updateSourceGroup({
    id: existing.id,
    name,
    sourceIds
  });
  const updateResult = updateMutation.updateSourceGroup;
  if (updateResult === void 0) {
    throw new Error("Failed to update source group");
  }
  return updateResult;
};
var getDirectPushFilter = (source, eventType, inputs) => {
  var _a;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === "DIRECT_TENANT_MESSAGES"
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve filter");
  }
  const type = resolveStringRef(eventType.name, eventType.directPushId, inputs);
  const filterOptions = {
    directMessageType: type
  };
  return {
    filter,
    filterOptions
  };
};
var getBroadcastFilter = (source, _eventType, _inputs) => {
  var _a;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === "BROADCAST_MESSAGES"
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve filter");
  }
  return {
    filter,
    filterOptions: {}
  };
};
var tradingPairInputsValidator = (inputs) => {
  if (typeof inputs.direction !== "string" || typeof inputs.price !== "number" || typeof inputs.pair !== "string") {
    return false;
  }
  return true;
};
var getTradingPairFilter = (source, eventType, inputs) => {
  var _a;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === "DIRECT_TENANT_MESSAGES"
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve TradingPair filter (=directMessage)");
  }
  const tradingPairs = resolveStringArrayRef(
    eventType.name,
    eventType.tradingPairs,
    inputs
  );
  if (tradingPairs.length === 0) throw new Error("No trading pairs found");
  const tradingPair = tradingPairInputsValidator(inputs) ? inputs.pair : tradingPairs[0];
  const value = tradingPairInputsValidator(inputs) ? inputs.price.toFixed(8) : "1.00000000";
  return {
    filter,
    filterOptions: {
      tradingPair,
      values: {
        and: [
          {
            key: "spotPrice",
            op: inputs.direction === "above" ? "gt" : "lt",
            value
          }
        ]
      }
    }
  };
};
var getPriceChangeFilter = (sources, _eventType, _inputs) => {
  const filter = sources.flatMap((it) => {
    var _a;
    return (_a = it.applicableFilters) != null ? _a : [];
  }).find((it) => (it == null ? void 0 : it.filterType) === "COIN_PRICE_CHANGE_EVENTS");
  if (filter === void 0) {
    throw new Error("Failed to retrieve filter");
  }
  return {
    filter,
    filterOptions: {}
  };
};
var getWalletBalanceSourceFilter = (source, _eventType, _inputs) => {
  var _a;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === "BALANCE"
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve filter: wallet balance");
  }
  return {
    filter,
    filterOptions: {}
  };
};
var getFusionSourceFilter = (source, eventType, inputs) => {
  var _a, _b;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === "FUSION_SOURCE"
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve fusion source filter");
  }
  let filterOptions = {};
  if (eventType.selectedUIType === "TOGGLE" || eventType.selectedUIType === "MULTI_THRESHOLD") {
    if (eventType.alertFrequency !== void 0) {
      filterOptions = {
        alertFrequency: eventType.alertFrequency
      };
    }
  } else if (eventType.selectedUIType === "HEALTH_CHECK") {
    const healthRatioKey = `${eventType.name}__healthRatio`;
    if (!inputs[healthRatioKey]) {
      inputs[`${eventType.name}__healthRatio`] = eventType.checkRatios[1].ratio;
    }
    const healthRatio = resolveNumberRef(
      healthRatioKey,
      { type: "ref", ref: healthRatioKey },
      inputs
    );
    const thresholdDirectionKey = `${eventType.name}__healthThresholdDirection`;
    if (!inputs[thresholdDirectionKey]) {
      inputs[thresholdDirectionKey] = eventType.checkRatios[0].type === "above" ? "above" : "below";
    }
    const thresholdDirection = (_b = resolveStringRef(
      thresholdDirectionKey,
      { type: "ref", ref: thresholdDirectionKey },
      inputs
    )) != null ? _b : eventType.checkRatios[0].ratio;
    if (!healthRatio || !thresholdDirection) {
      throw new Error("Failed to retrieve health ratio or direction");
    }
    filterOptions = {
      alertFrequency: eventType.alertFrequency,
      threshold: eventType.numberType === "percentage" ? healthRatio / 100 : healthRatio,
      thresholdDirection: thresholdDirection === "above" ? "above" : "below"
    };
  }
  return {
    filter,
    filterOptions
  };
};
var getCustomFilterOptions = (eventType, inputs) => {
  var _a, _b;
  switch (eventType.selectedUIType) {
    case "TOGGLE":
      return eventType.filterOptions;
    case "HEALTH_CHECK": {
      const healthRatioKey = `${eventType.name}__healthRatio`;
      const healthRatio = (_a = resolveNumberRef(
        healthRatioKey,
        { type: "ref", ref: healthRatioKey },
        inputs
      )) != null ? _a : eventType.checkRatios[0].ratio;
      const thresholdDirectionKey = `${eventType.name}__healthThresholdDirection`;
      const thresholdDirection = (_b = resolveStringRef(
        thresholdDirectionKey,
        { type: "ref", ref: thresholdDirectionKey },
        inputs
      )) != null ? _b : eventType.checkRatios[0].ratio;
      if (!healthRatio || !thresholdDirection) {
        throw new Error("Failed to retrieve health ratio or direction");
      }
      return {
        alertFrequency: eventType.alertFrequency,
        threshold: eventType.numberType === "percentage" ? healthRatio / 100 : healthRatio,
        thresholdDirection: thresholdDirection === "above" ? "above" : "below"
      };
    }
  }
};
var getCustomFilter = (source, eventType, inputs) => {
  var _a;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === eventType.filterType
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve filter");
  }
  return {
    filter,
    filterOptions: getCustomFilterOptions(eventType, inputs)
  };
};
var getXMTPFilter = (source, _eventType, _inputs) => {
  var _a;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === "WEB3_CHAT_MESSAGES"
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve filter: XMTP");
  }
  return {
    filter,
    filterOptions: {}
  };
};
var checkInputsIsWithIndex = (inputs) => {
  if ("index" in inputs) {
    return true;
  }
  return false;
};
var getHealthCheckFilter = (source, eventType, inputs) => {
  var _a;
  const filter = (_a = source.applicableFilters) == null ? void 0 : _a.find(
    (it) => (it == null ? void 0 : it.filterType) === "VALUE_THRESHOLD"
  );
  if (filter === void 0) {
    throw new Error("Failed to retrieve filter: healthCheck");
  }
  const checkRatios = resolveCheckRatioArrayRef(
    eventType.name,
    eventType.checkRatios,
    inputs
  );
  let threshold = checkRatios[0].ratio;
  let thresholdDirection = checkRatios[0].type;
  const checkInputsIsWithCustomPercentage = (inputs2) => {
    if ("customPercentage" in inputs2 && "thresholdDirection" in inputs2) {
      return true;
    }
    return false;
  };
  if (checkInputsIsWithIndex(inputs)) {
    threshold = checkRatios[inputs.index].ratio;
    thresholdDirection = checkRatios[inputs.index].type;
  } else if (checkInputsIsWithCustomPercentage(inputs)) {
    threshold = inputs.customPercentage;
    thresholdDirection = inputs.thresholdDirection;
  }
  return {
    filter,
    filterOptions: {
      alertFrequency: eventType.alertFrequency,
      threshold,
      thresholdDirection
    }
  };
};
var ensureSourceAndFilters = async (service, eventType, inputs) => {
  const sources = await ensureSources(service, eventType, inputs);
  const sourceGroup = await ensureSourceGroup(
    service,
    eventType.name,
    sources.map((it) => it.id)
  );
  switch (eventType.type) {
    case "directPush": {
      const { filter, filterOptions } = getDirectPushFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "broadcast": {
      const { filter, filterOptions } = getBroadcastFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "tradingPair": {
      if (!tradingPairInputsValidator(inputs)) {
        throw new Error("Invalid tradingPair inputs");
      }
      const { filter, filterOptions } = getTradingPairFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "priceChange": {
      const { filter, filterOptions } = getPriceChangeFilter(
        sources,
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "custom": {
      const { filter, filterOptions } = getCustomFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "XMTP": {
      const { filter, filterOptions } = getXMTPFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "healthCheck": {
      const { filter, filterOptions } = getHealthCheckFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "label": {
      throw new Error("Unsupported event type");
    }
    case "walletBalance": {
      const { filter, filterOptions } = getWalletBalanceSourceFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    case "fusionToggle":
    case "fusion": {
      const { filter, filterOptions } = getFusionSourceFilter(
        sources[0],
        eventType,
        inputs
      );
      return {
        sourceGroup,
        filter,
        filterOptions
      };
    }
    default:
      throw new Error("Unsupported event type");
  }
};

// lib/client/ensureTarget.ts
var ensureTarget = (create, fetch, identify, valueTransform) => {
  return async (service, value) => {
    if (value === void 0) {
      return void 0;
    }
    const existing = await fetch(service);
    const transformedValue = valueTransform !== void 0 ? valueTransform(value) : value;
    const found = existing == null ? void 0 : existing.find((it) => identify(it) === transformedValue);
    if (found !== void 0) {
      return found.id;
    }
    const created = await create(service, transformedValue);
    return created.id;
  };
};
var ensureEmail = ensureTarget(
  async (service, value) => {
    const mutation = await service.createEmailTarget({
      name: value.toLowerCase(),
      value: value.toLowerCase()
    });
    const result = mutation.createEmailTarget;
    if (result === void 0) {
      throw new Error("Failed to create email target");
    }
    return result;
  },
  async (service) => {
    const query = await service.getEmailTargets({});
    return query.emailTarget;
  },
  (arg) => {
    var _a;
    return (_a = arg == null ? void 0 : arg.emailAddress) == null ? void 0 : _a.toLowerCase();
  },
  (value) => value.toLowerCase()
);
var ensureSms = ensureTarget(
  async (service, value) => {
    const mutation = await service.createSmsTarget({
      name: value,
      value
    });
    const result = mutation.createSmsTarget;
    if (result === void 0) {
      throw new Error("Failed to create sms target");
    }
    return result;
  },
  async (service) => {
    const query = await service.getSmsTargets({});
    return query.smsTarget;
  },
  (arg) => arg == null ? void 0 : arg.phoneNumber
);
var ensureTelegram = ensureTarget(
  async (service, value) => {
    const mutation = await service.createTelegramTarget({
      name: value.toLowerCase(),
      value: value.toLowerCase()
    });
    const result = mutation.createTelegramTarget;
    if (result === void 0) {
      throw new Error("Failed to create telegramTarget");
    }
    return result;
  },
  async (service) => {
    const query = await service.getTelegramTargets({});
    return query.telegramTarget;
  },
  (arg) => {
    var _a;
    return (_a = arg == null ? void 0 : arg.telegramId) == null ? void 0 : _a.toLowerCase();
  },
  (value) => value.toLowerCase()
);
var ensureDiscord = ensureTarget(
  async (service, value) => {
    const mutation = await service.createDiscordTarget({
      name: value,
      value
    });
    const result = mutation.createDiscordTarget;
    if (result === void 0) {
      throw new Error("Failed to create discordTarget");
    }
    return result;
  },
  async (service) => {
    const query = await service.getDiscordTargets({});
    return query.discordTarget;
  },
  (arg) => arg == null ? void 0 : arg.name,
  () => "Default"
);
var ensureSlack = ensureTarget(
  async (service, value) => {
    const mutation = await service.createSlackChannelTarget({
      name: value,
      value
    });
    const result = mutation.createSlackChannelTarget.slackChannelTarget;
    if (result === void 0) {
      throw new Error("Failed to create slackTarget");
    }
    return result;
  },
  async (service) => {
    var _a;
    const query = await service.getSlackChannelTargets({});
    return (_a = query.slackChannelTargets) == null ? void 0 : _a.nodes;
  },
  (arg) => arg == null ? void 0 : arg.name,
  () => "Default"
);
var ensureWeb3 = ensureTarget(
  async (service, value) => {
    const mutation = await service.createWeb3Target({
      name: value,
      accountId: "",
      walletBlockchain: "OFF_CHAIN",
      web3TargetProtocol: "XMTP"
    });
    const result = mutation.createWeb3Target;
    if (result === void 0 || result.id === void 0) {
      throw new Error("Failed to create web3Target");
    }
    return result;
  },
  async (service) => {
    var _a;
    const query = await service.getWeb3Targets({});
    return (_a = query.web3Targets) == null ? void 0 : _a.nodes;
  },
  (arg) => arg == null ? void 0 : arg.name,
  () => "Default"
);
var ensureWebhook = async (service, params) => {
  if (params === void 0) {
    return void 0;
  }
  const query = await service.getWebhookTargets({});
  const existing = query.webhookTarget;
  const found = existing == null ? void 0 : existing.find(
    (it) => (it == null ? void 0 : it.url.toLowerCase()) === params.url.toLowerCase() && (it == null ? void 0 : it.format) === params.format
  );
  if (found !== void 0) {
    return found.id;
  }
  const mutation = await service.createWebhookTarget(__spreadProps(__spreadValues({}, params), {
    name: params.url.toLowerCase(),
    url: params.url.toLowerCase()
  }));
  const created = mutation.createWebhookTarget;
  if (created === void 0) {
    throw new Error("Failed to create webhook target");
  }
  return created.id;
};

// lib/storage/InMemoryStorageDriver.ts
var getEnvPrefix = (env) => {
  if (!env) env = "Production";
  switch (env) {
    case "Production":
      return "notifi-jwt";
    case "Development":
      return "notifi-jwt:dev";
    case "Staging":
      return "notifi-jwt:stg";
    case "Local":
      return "notifi-jwt:local";
  }
};
var createInMemoryStorageDriver = (config) => {
  let keyPrefix = `${getEnvPrefix(config.env || "Production")}:${config.tenantId}:${config.walletBlockchain}`;
  if (checkIsConfigWithOidc(config)) {
    keyPrefix += `:${config.userAccount}`;
  } else if (checkIsConfigWithPublicKeyAndAddress(config)) {
    keyPrefix += `:${config.accountAddress}:${config.authenticationKey}`;
  } else if (checkIsConfigWithDelegate(config)) {
    keyPrefix += `:${config.delegatorAddress}`;
  } else {
    keyPrefix += `:${config.walletPublicKey}`;
  }
  const storageBackend = {};
  const storageDriver = {
    get: (key) => {
      const newKey = `${keyPrefix}:${key}`;
      let result = null;
      if (newKey in storageBackend) {
        const json = storageBackend[newKey];
        result = JSON.parse(json);
      }
      return Promise.resolve(result);
    },
    set: (key, newValue) => {
      const newKey = `${keyPrefix}:${key}`;
      if (newValue === null) {
        delete storageBackend[newKey];
      } else {
        storageBackend[newKey] = JSON.stringify(newValue);
      }
      return Promise.resolve();
    },
    has: (key) => {
      const newKey = `${keyPrefix}:${key}`;
      return Promise.resolve(newKey in storageBackend);
    }
  };
  return storageDriver;
};

// lib/storage/NotifiFrontendStorage.ts
var KEY_AUTHORIZATION = "authorization";
var KEY_ROLES = "roles";
var NotifiFrontendStorage = class {
  constructor(_driver) {
    this._driver = _driver;
  }
  getAuthorization() {
    return this._driver.get(KEY_AUTHORIZATION);
  }
  setAuthorization(newValue) {
    return this._driver.set(KEY_AUTHORIZATION, newValue);
  }
  hasAuthorization() {
    return this._driver.has(KEY_AUTHORIZATION);
  }
  getRoles() {
    return this._driver.get(KEY_ROLES);
  }
  setRoles(newValue) {
    return this._driver.set(KEY_ROLES, newValue);
  }
  hasRoles() {
    return this._driver.has(KEY_ROLES);
  }
};

// lib/storage/LocalForageStorageDriver.ts
import localforage from "localforage";
localforage.config({
  name: "notifi"
});
var getEnvPrefix2 = (env) => {
  if (!env) env = "Production";
  switch (env) {
    case "Production":
      return "notifi-jwt";
    case "Development":
      return "notifi-jwt:dev";
    case "Staging":
      return "notifi-jwt:stg";
    case "Local":
      return "notifi-jwt:local";
  }
};
var createLocalForageStorageDriver = (config) => {
  let keyPrefix = `${getEnvPrefix2(config.env)}:${config.tenantId}:${config.walletBlockchain}`;
  if (checkIsConfigWithOidc(config)) {
    keyPrefix += `:${config.userAccount}`;
  } else if (checkIsConfigWithPublicKeyAndAddress(config)) {
    keyPrefix += `:${config.accountAddress}:${config.authenticationKey}`;
  } else if (checkIsConfigWithDelegate(config)) {
    keyPrefix += `:${config.delegatorAddress}`;
  } else {
    keyPrefix += `:${config.walletPublicKey}`;
  }
  const storageDriver = {
    get: async (key) => {
      const item = await localforage.getItem(`${keyPrefix}:${key}`);
      return item;
    },
    set: async (key, newValue) => {
      await localforage.setItem(`${keyPrefix}:${key}`, newValue);
    },
    has: async (key) => {
      const keys = await localforage.keys();
      return keys.indexOf(`${keyPrefix}:${key}`) >= 0;
    }
  };
  return storageDriver;
};

// lib/client/NotifiFrontendClient.ts
var SIGNING_MESSAGE_WITHOUT_NONCE = `Sign in with Notifi 

    No password needed or gas is needed. 

    Clicking \u201CApprove\u201D only means you have proved this wallet is owned by you! 

    This request will not trigger any transaction or cost any gas fees. 

    Use of our website and service is subject to our terms of service and privacy policy.`;
var SIGNING_MESSAGE = `${SIGNING_MESSAGE_WITHOUT_NONCE} 
 
 'Nonce:' `;
var CHAINS_WITH_LOGIN_WEB3 = ["XION", "APTOS", "MOVEMENT"];
function isLoginWeb3Params(params) {
  return CHAINS_WITH_LOGIN_WEB3.includes(
    params.walletBlockchain
  );
}
var NotifiFrontendClient = class {
  constructor(_configuration, _service, _storage) {
    this._configuration = _configuration;
    this._service = _service;
    this._storage = _storage;
    this._clientRandomUuid = null;
    this._userState = null;
  }
  get userState() {
    return this._userState;
  }
  async initialize() {
    const [storedAuthorization, roles] = await Promise.all([
      this._storage.getAuthorization(),
      this._storage.getRoles()
    ]);
    let authorization = storedAuthorization;
    if (authorization === null) {
      this._service.setJwt(void 0);
      const logOutStatus = {
        status: "loggedOut"
      };
      this._userState = logOutStatus;
      return logOutStatus;
    }
    const expiryDate = new Date(authorization.expiry);
    const now = /* @__PURE__ */ new Date();
    if (expiryDate <= now) {
      this._service.setJwt(void 0);
      const expiredStatus = {
        status: "expired",
        authorization
      };
      this._userState = expiredStatus;
      return expiredStatus;
    }
    const refreshTime = /* @__PURE__ */ new Date();
    refreshTime.setDate(now.getDate() + 7);
    if (expiryDate < refreshTime) {
      try {
        const refreshMutation = await this._service.refreshAuthorization({});
        const newAuthorization = refreshMutation.refreshAuthorization;
        if (newAuthorization !== void 0) {
          this._storage.setAuthorization(newAuthorization);
          authorization = newAuthorization;
        }
      } catch (e) {
        await this.logOut();
        console.error("Failed to refresh Notifi token:", e);
      }
    }
    this._service.setJwt(authorization.token);
    const userState = {
      status: "authenticated",
      authorization,
      roles: roles != null ? roles : []
    };
    this._userState = userState;
    return userState;
  }
  async logOut() {
    await Promise.all([
      this._storage.setAuthorization(null),
      this._storage.setRoles(null),
      this._service.logOut()
    ]);
    return {
      status: "loggedOut"
    };
  }
  async prepareLoginWithWeb3(signMessageParams) {
    if (signMessageParams.walletBlockchain === "XION") {
      const xionSignMessage = signMessageParams.signMessage;
      if (checkIsConfigWithDelegate(this._configuration)) {
        const { delegatedAddress, delegatedPublicKey, delegatorAddress } = this._configuration;
        const { nonce } = await this._beginLogInWithWeb3({
          authAddress: delegatorAddress,
          authType: "COSMOS_AUTHZ_GRANT"
        });
        const signedMessage = `${SIGNING_MESSAGE}${nonce}`;
        return {
          signMessageParams: {
            walletBlockchain: "XION",
            message: signedMessage,
            signMessage: xionSignMessage
          },
          signingAddress: delegatedAddress,
          signingPubkey: delegatedPublicKey,
          nonce
        };
      } else if (checkIsConfigWithPublicKeyAndAddress(this._configuration)) {
        const { authenticationKey, accountAddress } = this._configuration;
        const { nonce } = await this._beginLogInWithWeb3({
          authAddress: accountAddress,
          authType: "COSMOS_ADR36"
        });
        const signedMessage = `${SIGNING_MESSAGE}${nonce}`;
        return {
          signMessageParams: {
            walletBlockchain: "XION",
            message: signedMessage,
            signMessage: xionSignMessage
          },
          signingAddress: accountAddress,
          signingPubkey: authenticationKey,
          nonce
        };
      }
    }
    if (signMessageParams.walletBlockchain === "APTOS" || signMessageParams.walletBlockchain === "MOVEMENT") {
      const aptosSignMessage = signMessageParams.signMessage;
      if (checkIsConfigWithPublicKeyAndAddress(this._configuration)) {
        const { nonce } = await this._beginLogInWithWeb3({
          authAddress: this._configuration.accountAddress,
          authType: "APTOS_SIGNED_MESSAGE",
          walletPubkey: this._configuration.authenticationKey
        });
        return {
          signMessageParams: {
            walletBlockchain: signMessageParams.walletBlockchain,
            nonce,
            signMessage: aptosSignMessage
          },
          signingAddress: this._configuration.accountAddress,
          signingPubkey: this._configuration.authenticationKey,
          nonce
        };
      }
    }
    throw new Error(
      `Invalid loginWeb3Params: ${JSON.stringify(signMessageParams)}`
    );
  }
  async logInWithWeb3(loginWeb3Params) {
    if (!CHAINS_WITH_LOGIN_WEB3.includes(loginWeb3Params.walletBlockchain) || loginWeb3Params.walletBlockchain !== loginWeb3Params.walletBlockchain) {
      throw new Error(
        `Wallet blockchain must be one of ${CHAINS_WITH_LOGIN_WEB3.join(", ")} for loginWithWeb3`
      );
    }
    const { nonce, signingAddress, signingPubkey, signMessageParams } = await this.prepareLoginWithWeb3(loginWeb3Params);
    const authentication = await this._authenticate({
      signMessageParams,
      timestamp: Math.round(Date.now() / 1e3)
    });
    if (!("signature" in authentication)) {
      throw new Error("logInWith Web3 - Invalid signature - expected string");
    }
    const { completeLogInWithWeb3 } = await this.completeLogInWithWeb3({
      nonce,
      signature: authentication.signature,
      signedMessage: authentication.signedMessage,
      signingAddress,
      signingPubkey
    });
    return completeLogInWithWeb3.user;
  }
  async logIn(loginParams) {
    const timestamp = Math.round(Date.now() / 1e3);
    const { tenantId, walletBlockchain } = this._configuration;
    let user = void 0;
    if (isLoginWeb3Params(loginParams)) {
      user = await this.logInWithWeb3(loginParams);
    } else if (walletBlockchain === "OFF_CHAIN") {
      const authentication = await this._authenticate({
        signMessageParams: loginParams,
        timestamp
      });
      if (!("oidcProvider" in authentication)) {
        throw new Error("logIn - Invalid signature - expected OidcCredentials");
      }
      const { oidcProvider, jwt } = authentication;
      const result = await this._service.logInByOidc({
        dappId: tenantId,
        oidcProvider,
        idToken: jwt
      });
      user = result.logInByOidc.user;
    } else {
      const authentication = await this._authenticate({
        signMessageParams: loginParams,
        timestamp
      });
      if (!("signature" in authentication) || typeof authentication.signature !== "string") {
        throw new Error(
          "logIn - Invalid signature - expected string signature and signedMessage"
        );
      }
      switch (walletBlockchain) {
        case "BLAST":
        case "BERACHAIN":
        case "CELO":
        case "MANTLE":
        case "LINEA":
        case "SCROLL":
        case "MANTA":
        case "MONAD":
        case "BASE":
        case "THE_ROOT_NETWORK":
        case "ETHEREUM":
        case "POLYGON":
        case "ARBITRUM":
        case "AVALANCHE":
        case "BINANCE":
        case "OPTIMISM":
        case "ZKSYNC":
        case "EVMOS":
        case "SOLANA": {
          const result = await this._service.logInFromDapp({
            walletBlockchain,
            walletPublicKey: this._configuration.walletPublicKey,
            dappAddress: tenantId,
            timestamp,
            signature: authentication.signature
          });
          user = result.logInFromDapp;
          break;
        }
        case "SUI":
        case "ACALA":
        case "NEAR":
        case "INJECTIVE":
        case "OSMOSIS":
        case "ELYS":
        case "ARCHWAY":
        case "AXELAR":
        case "AGORIC":
        case "CELESTIA":
        case "COSMOS":
        case "DYMENSION":
        case "PERSISTENCE":
        case "DYDX":
        case "ORAI":
        case "KAVA":
        case "NEUTRON":
        case "NIBIRU":
        case "MOVEMENT":
        case "ARCH":
        case "APTOS": {
          const result = await this._service.logInFromDapp({
            walletBlockchain,
            walletPublicKey: this._configuration.authenticationKey,
            accountId: this._configuration.accountAddress,
            dappAddress: tenantId,
            timestamp,
            signature: authentication.signature
          });
          user = result.logInFromDapp;
          break;
        }
        default: {
          throw new Error(`Unsupported wallet blockchain: ${walletBlockchain}`);
        }
      }
    }
    if (user === void 0) {
      return Promise.reject("Failed to login");
    }
    await this._handleLogInResult(user);
    return user;
  }
  async _authenticate({
    signMessageParams,
    timestamp
  }) {
    if (this._configuration.walletBlockchain !== signMessageParams.walletBlockchain) {
      throw new Error(
        "Sign message params and configuration must have the same blockchain"
      );
    }
    switch (signMessageParams.walletBlockchain) {
      case "ETHEREUM":
      case "BERACHAIN":
      case "POLYGON":
      case "ARBITRUM":
      case "AVALANCHE":
      case "BINANCE":
      case "BASE":
      case "BLAST":
      case "CELO":
      case "MANTLE":
      case "LINEA":
      case "SCROLL":
      case "MANTA":
      case "MONAD":
      case "EVMOS":
      case "THE_ROOT_NETWORK":
      case "OPTIMISM": {
        const { walletPublicKey, tenantId } = this._configuration;
        const signedMessage = `${SIGNING_MESSAGE}${walletPublicKey}${tenantId}${timestamp.toString()}`;
        const messageBuffer = new TextEncoder().encode(signedMessage);
        const signedBuffer = await signMessageParams.signMessage(messageBuffer);
        const signature = normalizeHexString(
          Buffer.from(signedBuffer).toString("hex")
        );
        return { signature, signedMessage };
      }
      case "OSMOSIS":
      case "ZKSYNC":
      case "ELYS":
      case "NEUTRON":
      case "NIBIRU":
      case "ARCHWAY":
      case "AXELAR":
      case "AGORIC":
      case "CELESTIA":
      case "COSMOS":
      case "DYMENSION":
      case "PERSISTENCE":
      case "DYDX":
      case "ORAI":
      case "KAVA":
      case "INJECTIVE":
      case "ARCH":
      case "BITCOIN": {
        const { authenticationKey, tenantId } = this._configuration;
        const signedMessage = `${SIGNING_MESSAGE}${authenticationKey}${tenantId}${timestamp.toString()}`;
        const messageBuffer = new TextEncoder().encode(signedMessage);
        const signedBuffer = await signMessageParams.signMessage(messageBuffer);
        const signature = Buffer.from(signedBuffer).toString("base64");
        return { signature, signedMessage };
      }
      case "SOLANA": {
        const { walletPublicKey, tenantId } = this._configuration;
        const signedMessage = `${SIGNING_MESSAGE}${walletPublicKey}${tenantId}${timestamp.toString()}`;
        const messageBuffer = new TextEncoder().encode(signedMessage);
        const signedBuffer = await signMessageParams.signMessage(messageBuffer);
        const signature = Buffer.from(signedBuffer).toString("base64");
        return { signature, signedMessage };
      }
      case "XION": {
        const { message } = signMessageParams;
        const messageBuffer = new TextEncoder().encode(message);
        const signedBuffer = await signMessageParams.signMessage(messageBuffer);
        const signature = Buffer.from(signedBuffer).toString("base64");
        return { signature, signedMessage: message };
      }
      case "ACALA": {
        const { accountAddress, tenantId } = this._configuration;
        const message = `${SIGNING_MESSAGE}${accountAddress}${tenantId}${timestamp.toString()}`;
        const signedBuffer = await signMessageParams.signMessage(
          accountAddress,
          message
        );
        return { signature: signedBuffer, signedMessage: message };
      }
      case "APTOS":
      case "MOVEMENT": {
        const { signatureHex, signedMessage } = await signMessageParams.signMessage(
          SIGNING_MESSAGE_WITHOUT_NONCE,
          signMessageParams.nonce
        );
        return { signature: signatureHex, signedMessage };
      }
      case "SUI": {
        const { accountAddress, tenantId } = this._configuration;
        const signedMessage = `${SIGNING_MESSAGE}${accountAddress}${tenantId}${timestamp.toString()}`;
        const messageBuffer = new TextEncoder().encode(signedMessage);
        const signedBuffer = await signMessageParams.signMessage(messageBuffer);
        const signature = signedBuffer.toString();
        return { signature, signedMessage };
      }
      case "NEAR": {
        const { authenticationKey, accountAddress, tenantId } = this._configuration;
        const message = `${`ed25519:` + authenticationKey}${tenantId}${accountAddress}${timestamp.toString()}`;
        const textAsBuffer = new TextEncoder().encode(message);
        const hashBuffer = await window.crypto.subtle.digest(
          "SHA-256",
          textAsBuffer
        );
        const messageBuffer = new Uint8Array(hashBuffer);
        const signedBuffer = await signMessageParams.signMessage(messageBuffer);
        const signature = Buffer.from(signedBuffer).toString("base64");
        return { signature, signedMessage: message };
      }
      case "OFF_CHAIN": {
        const oidcCredentials = await signMessageParams.signIn();
        if (!oidcCredentials) {
          throw new Error("._authenticate: OIDC login failed");
        }
        return oidcCredentials;
      }
      default:
        return { signature: "chain not supported yet", signedMessage: "" };
    }
  }
  async _handleLogInResult(user) {
    const authorization = user == null ? void 0 : user.authorization;
    const saveAuthorizationPromise = authorization !== void 0 ? this._storage.setAuthorization(authorization) : Promise.resolve();
    const roles = user == null ? void 0 : user.roles;
    const saveRolesPromise = roles !== void 0 ? this._storage.setRoles(roles.filter(notNullOrEmpty)) : Promise.resolve();
    if (authorization && roles) {
      const userState = {
        status: "authenticated",
        authorization,
        roles: roles.filter((role) => !!role)
      };
      this._userState = userState;
    }
    await Promise.all([saveAuthorizationPromise, saveRolesPromise]);
  }
  async fetchFusionData() {
    return this._service.fetchFusionData({});
  }
  async beginLoginViaTransaction({
    walletBlockchain,
    walletAddress
  }) {
    const { tenantId } = this._configuration;
    const result = await this._service.beginLogInByTransaction({
      walletAddress,
      walletBlockchain,
      dappAddress: tenantId
    });
    const nonce = result.beginLogInByTransaction.nonce;
    if (nonce === null) {
      throw new Error("Failed to begin login process");
    }
    const ruuid = crypto.randomUUID();
    this._clientRandomUuid = ruuid;
    const encoder = new TextEncoder();
    const data = encoder.encode(nonce + ruuid);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    let prefix = "0x";
    if (walletBlockchain === "SOLANA" || walletBlockchain === "OSMOSIS") {
      prefix = "Notifi Auth: 0x";
    }
    const logValue = prefix + hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    return { nonce: logValue };
  }
  async completeLoginViaTransaction({
    walletBlockchain,
    walletAddress,
    transactionSignature
  }) {
    const { tenantId } = this._configuration;
    const clientRandomUuid = this._clientRandomUuid;
    this._clientRandomUuid = null;
    if (clientRandomUuid === null) {
      throw new Error(
        "BeginLoginViaTransaction is required to be called first"
      );
    }
    const result = await this._service.completeLogInByTransaction({
      walletAddress,
      walletBlockchain,
      dappAddress: tenantId,
      randomUuid: clientRandomUuid,
      transactionSignature
    });
    await this._handleLogInResult(result.completeLogInByTransaction);
    return result;
  }
  async _beginLogInWithWeb3({
    authType,
    authAddress,
    walletPubkey
  }) {
    const { tenantId } = this._configuration;
    const result = await this._service.beginLogInWithWeb3({
      dappAddress: tenantId,
      authAddress,
      blockchainType: this._configuration.walletBlockchain,
      authType,
      walletPubkey
    });
    if (!result.beginLogInWithWeb3.beginLogInWithWeb3Response) {
      throw new Error("Failed to begin login process");
    }
    return result.beginLogInWithWeb3.beginLogInWithWeb3Response;
  }
  async completeLogInWithWeb3(input) {
    const result = await this._service.completeLogInWithWeb3(__spreadValues({
      signingPubkey: ""
    }, input));
    return result;
  }
  async getTargetGroups() {
    var _a, _b;
    const query = await this._service.getTargetGroups({});
    const results = (_b = (_a = query.targetGroup) == null ? void 0 : _a.filter(notNullOrEmpty)) != null ? _b : [];
    return results;
  }
  async ensureTargetGroup({
    name,
    emailAddress,
    phoneNumber,
    telegramId,
    webhook,
    discordId,
    slackId,
    walletId
  }) {
    var _a;
    const [
      targetGroupsQuery,
      emailTargetId,
      smsTargetId,
      telegramTargetId,
      webhookTargetId,
      discordTargetId,
      slackTargetId,
      web3TargetId
    ] = await Promise.all([
      this._service.getTargetGroups({}),
      ensureEmail(this._service, emailAddress),
      ensureSms(this._service, phoneNumber),
      ensureTelegram(this._service, telegramId),
      ensureWebhook(this._service, webhook),
      ensureDiscord(this._service, discordId),
      ensureSlack(this._service, slackId),
      ensureWeb3(this._service, walletId)
    ]);
    const emailTargetIds = emailTargetId === void 0 ? [] : [emailTargetId];
    const smsTargetIds = smsTargetId === void 0 ? [] : [smsTargetId];
    const telegramTargetIds = telegramTargetId === void 0 ? [] : [telegramTargetId];
    const webhookTargetIds = webhookTargetId === void 0 ? [] : [webhookTargetId];
    const discordTargetIds = discordTargetId === void 0 ? [] : [discordTargetId];
    const slackChannelTargetIds = slackTargetId === void 0 ? [] : [slackTargetId];
    const web3TargetIds = web3TargetId === void 0 ? [] : [web3TargetId];
    const existing = (_a = targetGroupsQuery.targetGroup) == null ? void 0 : _a.find(
      (it) => (it == null ? void 0 : it.name) === name
    );
    if (existing !== void 0) {
      return this._updateTargetGroup({
        existing,
        emailTargetIds,
        smsTargetIds,
        telegramTargetIds,
        webhookTargetIds,
        discordTargetIds,
        slackChannelTargetIds,
        web3TargetIds
      });
    }
    const createMutation = await this._service.createTargetGroup({
      name,
      emailTargetIds,
      smsTargetIds,
      telegramTargetIds,
      webhookTargetIds,
      discordTargetIds,
      slackChannelTargetIds,
      web3TargetIds
    });
    if (createMutation.createTargetGroup === void 0) {
      throw new Error("Failed to create target group");
    }
    return createMutation.createTargetGroup;
  }
  async _updateTargetGroup({
    existing,
    emailTargetIds,
    smsTargetIds,
    telegramTargetIds,
    webhookTargetIds,
    discordTargetIds,
    slackChannelTargetIds,
    web3TargetIds
  }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (areIdsEqual(emailTargetIds, (_a = existing.emailTargets) != null ? _a : []) && areIdsEqual(smsTargetIds, (_b = existing.smsTargets) != null ? _b : []) && areIdsEqual(telegramTargetIds, (_c = existing.telegramTargets) != null ? _c : []) && areIdsEqual(webhookTargetIds, (_d = existing.webhookTargets) != null ? _d : []) && areIdsEqual(discordTargetIds, (_e = existing.discordTargets) != null ? _e : []) && areIdsEqual(slackChannelTargetIds, (_f = existing.slackChannelTargets) != null ? _f : []) && areIdsEqual(web3TargetIds, (_g = existing.web3Targets) != null ? _g : [])) {
      return existing;
    }
    const updateMutation = await this._service.updateTargetGroup({
      id: existing.id,
      name: (_h = existing.name) != null ? _h : existing.id,
      emailTargetIds,
      smsTargetIds,
      telegramTargetIds,
      webhookTargetIds,
      discordTargetIds,
      slackChannelTargetIds,
      web3TargetIds
    });
    const updated = updateMutation.updateTargetGroup;
    if (updated === void 0) {
      throw new Error("Failed to update target group");
    }
    return updated;
  }
  async getAlerts() {
    var _a, _b;
    const query = await this._service.getAlerts({});
    return (_b = (_a = query.alert) == null ? void 0 : _a.filter(notNullOrEmpty)) != null ? _b : [];
  }
  async ensureFusionAlerts(input) {
    const inputAlertsNames = new Set(input.alerts.map((alert) => alert.name));
    const query = await this._service.getAlerts({});
    const existingAlerts = new Set(query.alert);
    const duplicateAlerts = [...existingAlerts].filter(
      (alert) => inputAlertsNames.has(alert == null ? void 0 : alert.name)
    );
    const duplicateAlertsIds = duplicateAlerts.map((alert) => alert == null ? void 0 : alert.id).filter((id) => !!id);
    for (const id of duplicateAlertsIds) {
      await this.deleteAlert({ id });
    }
    const mutation = await this._service.createFusionAlerts({ input });
    return mutation.createFusionAlerts;
  }
  async deleteAlert({
    id
  }) {
    var _a;
    const mutation = await this._service.deleteAlert({ id });
    const result = (_a = mutation.deleteAlert) == null ? void 0 : _a.id;
    if (result === void 0) {
      throw new Error("Failed to delete alert");
    }
  }
  async updateWallets() {
    const walletEventTypeItem = {
      name: "User Wallets",
      type: "walletBalance"
    };
    const result = await ensureSourceAndFilters(
      this._service,
      walletEventTypeItem,
      {}
    );
    return result;
  }
  async getUnreadNotificationHistoryCount(cardId) {
    const query = await this._service.getUnreadNotificationHistoryCount({
      cardId
    });
    const result = query.unreadNotificationHistoryCount;
    if (!result) {
      throw new Error("Failed to fetch unread notification history count");
    }
    return result;
  }
  /**
   * @returns {string} - The id of the event listener (used to remove the event listener)
   */
  addEventListener(event, callBack, onError, onCompleted) {
    return this._service.addEventListener(
      event,
      callBack,
      onError,
      onCompleted
    );
  }
  removeEventListener(event, id) {
    return this._service.removeEventListener(event, id);
  }
  async getUserSettings() {
    const query = await this._service.getUserSettings({});
    const result = query.userSettings;
    if (!result) {
      throw new Error("Failed to fetch user settings");
    }
    return result;
  }
  async getFusionNotificationHistory(variables) {
    var _a, _b;
    const query = await this._service.getFusionNotificationHistory(variables);
    const nodes = (_a = query.fusionNotificationHistory) == null ? void 0 : _a.nodes;
    const pageInfo = (_b = query.fusionNotificationHistory) == null ? void 0 : _b.pageInfo;
    if (nodes === void 0 || pageInfo === void 0) {
      throw new Error("Failed to fetch notification history");
    }
    return { pageInfo, nodes };
  }
  async fetchTenantConfig(variables) {
    const query = await this._service.findTenantConfig({
      input: __spreadProps(__spreadValues({}, variables), {
        tenant: this._configuration.tenantId
      })
    });
    const result = query.findTenantConfig;
    if (result === void 0 || !result.dataJson || !result.fusionEvents) {
      throw new Error("Failed to find tenant config");
    }
    const tenantConfigJsonString = result.dataJson;
    if (tenantConfigJsonString === void 0) {
      throw new Error("Invalid config data");
    }
    const cardConfig = JSON.parse(tenantConfigJsonString);
    const fusionEventDescriptors = result.fusionEvents;
    if (!cardConfig || cardConfig.version !== "v1" || !fusionEventDescriptors)
      throw new Error("Unsupported config format");
    const fusionEventDescriptorMap = new Map(fusionEventDescriptors.map((item) => {
      var _a;
      return [(_a = item == null ? void 0 : item.name) != null ? _a : "", item != null ? item : {}];
    }));
    fusionEventDescriptorMap.delete("");
    const fusionEventTopics = cardConfig.eventTypes.map((eventType) => {
      if (eventType.type === "fusion") {
        const fusionEventDescriptor = fusionEventDescriptorMap.get(
          eventType.name
        );
        return {
          uiConfig: eventType,
          fusionEventDescriptor
        };
      }
    }).filter((item) => !!item);
    return { cardConfig, fusionEventTopics };
  }
  async copyAuthorization(config) {
    var _a;
    const auth = await this._storage.getAuthorization();
    const roles = await this._storage.getRoles();
    const driver = ((_a = config.storageOption) == null ? void 0 : _a.driverType) === "InMemory" ? createInMemoryStorageDriver(config) : createLocalForageStorageDriver(config);
    const otherStorage = new NotifiFrontendStorage(driver);
    await Promise.all([
      otherStorage.setAuthorization(auth),
      otherStorage.setRoles(roles)
    ]);
  }
  async sendEmailTargetVerification({
    targetId
  }) {
    var _a;
    const emailTarget = await this._service.sendEmailTargetVerificationRequest({
      targetId
    });
    const id = (_a = emailTarget.sendEmailTargetVerificationRequest) == null ? void 0 : _a.id;
    if (id === void 0) {
      throw new Error(`Unknown error requesting verification`);
    }
    return id;
  }
  async subscribeWallet(params) {
    if (params.walletParams.walletBlockchain === "OFF_CHAIN")
      throw new Error(
        "ERROR: subscribeWallet - OFF_CHAIN OIDC login does not support wallet connection"
      );
    const { walletBlockchain, signMessage, walletPublicKey } = params.walletParams;
    const signMessageParams = {
      walletBlockchain,
      signMessage
    };
    if (this._userState && this._userState.status === "authenticated") {
      await this.logIn(signMessageParams);
    }
    const timestamp = Math.round(Date.now() / 1e3);
    const signature = await this._authenticate({
      signMessageParams,
      timestamp
    });
    if (typeof signature !== "string")
      throw new Error("subscribeWallet - Invalid signature - expected string");
    const connectedWallet = await this._service.connectWallet({
      walletBlockchain,
      walletPublicKey,
      accountId: walletBlockchain === "APTOS" || walletBlockchain === "MOVEMENT" || walletBlockchain === "ACALA" || walletBlockchain === "NEAR" || walletBlockchain === "SUI" ? params.walletParams.accountAddress : void 0,
      signature,
      timestamp,
      connectWalletConflictResolutionTechnique: params.connectWalletConflictResolutionTechnique
    });
    return connectedWallet;
  }
  async createDiscordTarget(input) {
    const mutation = await this._service.createDiscordTarget({
      name: input,
      value: input
    });
    return mutation.createDiscordTarget;
  }
  async markFusionNotificationHistoryAsRead(input) {
    const mutation = await this._service.markFusionNotificationHistoryAsRead(input);
    return mutation;
  }
  async updateUserSettings(input) {
    const mutation = await this._service.updateUserSettings(input);
    return mutation;
  }
  async verifyXmtpTarget(input) {
    const mutation = await this._service.verifyXmtpTarget(input);
    return mutation;
  }
  async verifyCbwTarget(input) {
    const mutation = await this._service.verifyCbwTarget(input);
    return mutation;
  }
  async verifyXmtpTargetViaXip42(input) {
    const mutation = await this._service.verifyXmtpTargetViaXip42(input);
    return mutation;
  }
  async createWebPushTarget(input) {
    const mutation = await this._service.createWebPushTarget(input);
    return mutation;
  }
  async updateWebPushTarget(input) {
    const mutation = await this._service.updateWebPushTarget(input);
    return mutation;
  }
  async deleteWebPushTarget(input) {
    const mutation = await this._service.deleteWebPushTarget(input);
    return mutation;
  }
  async getWebPushTargets(input) {
    const query = await this._service.getWebPushTargets(input);
    const result = query.webPushTargets;
    if (!result) {
      throw new Error("Failed to fetch webpush targets");
    }
    return result;
  }
  /** ⬇ Deprecated methods */
  /** @deprecated only for legacy infrastructure */
  async getSourceGroups() {
    var _a, _b;
    const query = await this._service.getSourceGroups({});
    const results = (_b = (_a = query.sourceGroup) == null ? void 0 : _a.filter(notNullOrEmpty)) != null ? _b : [];
    return results;
  }
  /**
   * @deprecated use the return type of addEventListener & removeEventListener instead.
   * @description never use this when having multiple gql subscription in the app. This case, dispose websocket could break other subscriptions.
   */
  async wsDispose() {
    this._service.wsDispose();
  }
  /**
   * @deprecated Use getFusionNotificationHistory instead
   */
  async getNotificationHistory(variables) {
    var _a, _b;
    const query = await this._service.getNotificationHistory(variables);
    const nodes = (_a = query.notificationHistory) == null ? void 0 : _a.nodes;
    const pageInfo = (_b = query.notificationHistory) == null ? void 0 : _b.pageInfo;
    if (nodes === void 0 || pageInfo === void 0) {
      throw new Error("Failed to fetch notification history");
    }
    return { pageInfo, nodes };
  }
  /**
   * @deprecated use addEventListener instead.
   */
  subscribeNotificationHistoryStateChanged(onMessageReceived, onError, onComplete) {
    return this._service.subscribeNotificationHistoryStateChanged(
      onMessageReceived,
      onError,
      onComplete
    );
  }
  /** @deprecated legacy infrastructure, use ensureFusionAlerts instead */
  async ensureAlert({
    eventType,
    inputs,
    targetGroupName = "Default"
  }) {
    var _a, _b;
    const [alertsQuery, targetGroupsQuery, sourceAndFilters] = await Promise.all([
      this._service.getAlerts({}),
      this._service.getTargetGroups({}),
      ensureSourceAndFilters(this._service, eventType, inputs)
    ]);
    const targetGroup = (_a = targetGroupsQuery.targetGroup) == null ? void 0 : _a.find(
      (it) => (it == null ? void 0 : it.name) === targetGroupName
    );
    if (targetGroup === void 0) {
      throw new Error("Target group does not exist");
    }
    const { sourceGroup, filter, filterOptions } = sourceAndFilters;
    const packedOptions = packFilterOptions(filterOptions);
    const existing = (_b = alertsQuery.alert) == null ? void 0 : _b.find(
      (it) => it !== void 0 && it.name === eventType.name
    );
    if (existing !== void 0) {
      if (existing.sourceGroup.id === sourceGroup.id && existing.targetGroup.id === targetGroup.id && existing.filter.id === filter.id && existing.filterOptions === packedOptions) {
        return existing;
      }
      await this.deleteAlert({
        id: existing.id
      });
    }
    const mutation = await this._service.createAlert({
      name: eventType.name,
      sourceGroupId: sourceGroup.id,
      filterId: filter.id,
      targetGroupId: targetGroup.id,
      filterOptions: packedOptions,
      groupName: "managed"
    });
    const created = mutation.createAlert;
    if (created === void 0) {
      throw new Error("Failed to create alert");
    }
    return created;
  }
  /** @deprecated use fetchFusionData instead. This is for legacy  */
  async fetchData() {
    return this._service.fetchData({});
  }
  /**@deprecated for legacy infra, use fetchTenantConfig instead for new infra (fusionEvent)  */
  async fetchSubscriptionCard(variables) {
    const query = await this._service.findTenantConfig({
      input: __spreadProps(__spreadValues({}, variables), {
        tenant: this._configuration.tenantId
      })
    });
    const result = query.findTenantConfig;
    if (result === void 0) {
      throw new Error("Failed to find tenant config");
    }
    const value = result.dataJson;
    if (value === void 0) {
      throw new Error("Invalid config data");
    }
    const obj = JSON.parse(value);
    let card = void 0;
    switch (obj.version) {
      case "v1": {
        card = obj;
        break;
      }
      default: {
        throw new Error("Unsupported config version");
      }
    }
    if (card === void 0) {
      throw new Error("Unsupported config format");
    }
    return card;
  }
};

// lib/client/clientFactory.ts
import {
  NotifiService,
  NotifiSubscriptionService
} from "@notifi-network/notifi-graphql";
import { GraphQLClient } from "graphql-request";
import WebSocket from "ws";
var newNotifiStorage = (config) => {
  var _a;
  const driver = ((_a = config.storageOption) == null ? void 0 : _a.driverType) === "InMemory" ? createInMemoryStorageDriver(config) : createLocalForageStorageDriver(config);
  return new NotifiFrontendStorage(driver);
};
var newNotifiService = (config, gqlClientRequestConfig) => {
  const url = envUrl(config.env, "http");
  const wsurl = envUrl(config.env, "websocket");
  const client = new GraphQLClient(url, gqlClientRequestConfig);
  const subService = new NotifiSubscriptionService(
    wsurl,
    /** NOTE - websocketImpl arg:
     * - In browser env, adopt global WebSocket automatically.
     * - In Node.js env, manually pass in WebSocket Implementation.
     * @ref https://github.com/enisdenjo/graphql-ws/blob/c030ed1d5f7e8a552dffbfd46712caf7dfe91a54/src/client.ts#L400
     */
    typeof window !== "undefined" ? void 0 : WebSocket
  );
  return new NotifiService(client, subService);
};
var newFrontendClient = (args) => {
  const config = newFrontendConfig(args);
  const service = newNotifiService(config);
  const storage = newNotifiStorage(config);
  return new NotifiFrontendClient(config, service, storage);
};
var instantiateFrontendClient = (tenantId, params, env, storageOption, gqlClientRequestConfig) => {
  let config = null;
  if ("accountAddress" in params) {
    config = {
      tenantId,
      env,
      walletBlockchain: params.walletBlockchain,
      authenticationKey: params.walletPublicKey,
      // NOTE: authenticationKey is a legacy field used to standardize the key name for indexedDB key. Now we directly add check condition when create storage driver
      accountAddress: params.accountAddress,
      storageOption
    };
  } else if ("signingPubkey" in params) {
    config = {
      tenantId,
      env,
      walletBlockchain: params.walletBlockchain,
      delegatedAddress: params.signingAddress,
      delegatedPublicKey: params.walletPublicKey,
      delegatorAddress: params.signingPubkey,
      storageOption
    };
  } else if ("userAccount" in params) {
    config = {
      tenantId,
      env,
      userAccount: params.userAccount,
      storageOption,
      walletBlockchain: params.walletBlockchain
    };
  } else {
    config = {
      tenantId,
      env,
      walletBlockchain: params.walletBlockchain,
      walletPublicKey: isEvmChain(params.walletBlockchain) ? params.walletPublicKey.toLowerCase() : params.walletPublicKey,
      storageOption
    };
  }
  if (!config) {
    throw new Error("ERROR - instantiateFrontendClient: Invalid UserParams");
  }
  const service = newNotifiService(config, gqlClientRequestConfig);
  const storage = newNotifiStorage(config);
  return new NotifiFrontendClient(config, service, storage);
};
export {
  NotifiFrontendClient,
  NotifiFrontendStorage,
  SIGNING_MESSAGE,
  checkIsConfigWithDelegate,
  checkIsConfigWithOidc,
  checkIsConfigWithPublicKeyAndAddress,
  createInMemoryStorageDriver,
  createLocalForageStorageDriver,
  ensureDiscord,
  ensureEmail,
  ensureSlack,
  ensureSms,
  ensureSourceAndFilters,
  ensureTarget,
  ensureTelegram,
  ensureWeb3,
  ensureWebhook,
  envUrl,
  instantiateFrontendClient,
  isEvmChain,
  newFrontendClient,
  newFrontendConfig,
  newNotifiService,
  newNotifiStorage,
  normalizeHexString,
  notNullOrEmpty,
  objectKeys,
  packFilterOptions,
  resolveCheckRatioArrayRef,
  resolveNumberRef,
  resolveObjectArrayRef,
  resolveStringArrayRef,
  resolveStringRef
};
